<div class="action-arrow__content">
	<button class="btn-primary btn btn-sm" (click)="onViewLog()">				
		Log
		<i class="fas fa-brackets-curly"></i>
	</button>
</div>